import circularRegular from '../../fonts/CircularStd-Book.woff'
import circularBold from '../../fonts/CircularStd-Bold.woff'
import ahkioRegular from '../../fonts/Ahkio-Regular.woff'
import ahkioBold from '../../fonts/Ahkio-Bold.woff'
import ahkioBlack from '../../fonts/Ahkio-Black.woff'

export const bodyFont = circularRegular
export const bodyFontBold = circularBold
export const headerFontRegular = ahkioRegular
export const headerFontBold = ahkioBold
export const headerFontBlack = ahkioBlack



// WEBPACK FOOTER //
// ./src/styles/typography/fontFiles.js